import MobileSliderPagesWrapper from '../../components/MobileSliderPagesWrapper';
import MobileSliderPagesHeader from '../../components/MobileSliderPagesHeader';
import { MobileSliderPagesContentStyled } from '../../components/styled/MobileSliderPagesStyled';
import { useLangContext } from '../../../../../providers/LangProvider/LangProviderContext';
import { useDispatch, useSelector } from 'react-redux';
import { getDomainConfig } from '../../../../../app/appSelectors';
import PwaIosInstructionLoadable
    from '../../../../../modules/Pwa/components/PwaIosInstruction/PwaIosInstructionLoadable';
import { useCallback } from 'react';
import { closeMobileSliderPageAction } from '../../../../mobileAppActions';

function SlidePwaIosInstruction() {
    const { getLangPath } = useLangContext();
    const domainConfig = useSelector(getDomainConfig);
    const dispatch = useDispatch();

    const onGotItClickHandler = useCallback(() => {
        dispatch(closeMobileSliderPageAction());
    }, [dispatch]);

    return <MobileSliderPagesWrapper>
        <MobileSliderPagesHeader>
            {getLangPath('pwa.ios.slide_instruction_title', { app_title: domainConfig?.appTitle })}
        </MobileSliderPagesHeader>
        <MobileSliderPagesContentStyled>
            <PwaIosInstructionLoadable onGotItClick={onGotItClickHandler}/>
        </MobileSliderPagesContentStyled>
    </MobileSliderPagesWrapper>
}

export default SlidePwaIosInstruction;
